import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a2c7e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_iap_counter_badge = _resolveComponent("iap-counter-badge")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 0,
          class: "counter-badge-spinner",
          color: "primary",
          size: "1em"
        }))
      : (_openBlock(), _createBlock(_component_iap_counter_badge, _mergeProps({ key: 1 }, _ctx.BADGE_ROUNDED_MD, {
          limit: 0,
          count: _ctx.rowsCount
        }), null, 16, ["count"])),
    (_ctx.showOutOf)
      ? (_openBlock(), _createElementBlock("span", _normalizeProps(_mergeProps({ key: 2 }, _ctx.TEXT_HEADER_BODY)), _toDisplayString(_ctx.t('OUT_OF', { nb: _ctx.totalCount })), 17))
      : _createCommentVNode("", true)
  ]))
}